import React, { useState } from 'react';
import { Card, Icon } from '../../common';

export interface DataViewerProps {
  title: string;
  data: any;
  hasData: boolean;
}

export const DataViewer: React.FC<DataViewerProps> = ({
  title,
  data,
  hasData
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Card className="mb-6">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-between w-full text-left"
      >
        <h3 className="text-xl font-normal text-[#424242] flex items-center gap-2">
          <Icon name="code" className="w-5 h-5" />
          {title}
        </h3>
        <Icon 
          name={isExpanded ? "chevron-up" : "chevron-down"} 
          className="w-5 h-5 text-gray-500" 
        />
      </button>

      {isExpanded && (
        <div className="mt-4">
          {hasData && (
            <div className="bg-[#DCDCDC] border border-[#DCDCDC] rounded-lg p-3 mb-4">
              <div className="flex items-center">
                <h4 className="text-sm font-semibold text-[#888888] mb-1">✓ Datos Disponibles</h4>
              </div>
            </div>
          )}
          
          {hasData ? (
            <div>
              <h4 className="font-medium text-gray-700 mb-2">Contenido:</h4>
              <pre className="bg-gray-50 p-3 rounded-md text-sm overflow-x-auto max-h-96 overflow-y-auto">
                {typeof data === 'string' ? data : JSON.stringify(data, null, 2)}
              </pre>
            </div>
          ) : (
            <p className="text-gray-500 italic">No hay datos disponibles</p>
          )}
        </div>
      )}
    </Card>
  );
};